/** @format */

import { useDispatch, useSelector } from "react-redux";
//import components
import {
  showChildService,
  showDeleteModal,
  showSectionService,
  showService,
} from "../../store/stateSlice";
import { ServiceCard } from "../../components/service-card";
import HeadTitle from "../../components/global/HeadTitle";
//importing assets
import Pic1 from "../../Assets/images/ahmedeldesoky.jpeg";
import { delOne, getAll, getOne } from "../../store/helper";
import { imgUrl } from "../../store/api";
import DeleteModal from "../../components/pops/global modals/deleteModal";
import { useState } from "react";
import {
  setCategoryID,
  setDelete,
  setEdit,
  setServicesCategory,
} from "../../store/category";
import { useEffect } from "react";
import service, { setServiceCatIDS } from "../../store/service";

const ServicesContainer = (props) => {
  const [services, setServices] = useState([]);
  // const { addChildService } = props;
  const dispatch = useDispatch();

  const category = useSelector((state) => state.category);
  const render = useSelector((state) => state.toggleState.value.render);

  //function to show delete Modal
  const handleDeleteModal = (_id) => {
    dispatch(setCategoryID({ id: _id }));
    dispatch(setDelete({ delete: true }));
    dispatch(setEdit({ edit: false }));
    dispatch(showDeleteModal());
  };
  const handleEditModal = (_id) => {
    dispatch(setCategoryID({ id: _id }));
    dispatch(setDelete({ delete: false }));
    dispatch(setEdit({ edit: true }));
    dispatch(showSectionService());
  };

  const handleAddService = (_id) => {
    dispatch(setServiceCatIDS({ categoryID: _id }));
    dispatch(showChildService());
  };

  useEffect(() => {
    getAllServices();
    // dispatch(
    //   getOne({
    //     path: "/get_services_by_category/",
    //     id: props.item.id,
    //   })
    // ).then((res) => console.log("60", res));
  }, [dispatch, render]);
  const getAllServices = () => {
    dispatch(
      getOne({
        path: "/get_services_by_category/",
        id: props.item.id,
      })
    ).then((res) => {
      setServices(res.payload.data);
    });
  };
  return (
    <div className='services-domains__container'>
      {category.delete && (
        <DeleteModal
          from='category'
          id={props.item.id}
          getAllServices={getAllServices}
        />
      )}
      <div className='services-domains__head flex-between'>
        <div className='services-domains__head-card'>
          <img
            className='services-domains__head-card__img'
            alt=''
            src={props.item.image ? imgUrl + props.item.image : Pic1}
          />
          <HeadTitle title={props.item.name_ar} small={true} />
        </div>
        <div>
          <p className='services-domains__buttons'>
            <p
              className='services-domains__edit'
              onClick={() => handleEditModal(props.item.id)}>
              تعديل
            </p>
            <p
              className='services-domains__delete'
              onClick={() => handleDeleteModal(props.item.id)}>
              حذف
            </p>
          </p>
        </div>
      </div>
      <div className=' services-domains__content'>
        {services?.map((item, key) => (
          <ServiceCard
            from='service-domains'
            item={item}
            key={key}
            getAllServices={getAllServices}
          />
        ))}
        {props.addService && (
          <div
            className=' services-domains__add-service '
            onClick={() => handleAddService(props.item.id)}>
            <p className=' services-domains__add-service-plus'>
              <svg
                width='37'
                height='37'
                viewBox='0 0 37 37'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'>
                <path
                  fillRule='evenodd'
                  clipRule='evenodd'
                  d='M18.5 0C18.9089 0 19.301 0.162425 19.5901 0.451544C19.8792 0.740663 20.0417 1.13279 20.0417 1.54167V16.9583H35.4583C35.8672 16.9583 36.2593 17.1208 36.5485 17.4099C36.8376 17.699 37 18.0911 37 18.5C37 18.9089 36.8376 19.301 36.5485 19.5901C36.2593 19.8792 35.8672 20.0417 35.4583 20.0417H20.0417V35.4583C20.0417 35.8672 19.8792 36.2593 19.5901 36.5485C19.301 36.8376 18.9089 37 18.5 37C18.0911 37 17.699 36.8376 17.4099 36.5485C17.1208 36.2593 16.9583 35.8672 16.9583 35.4583V20.0417H1.54167C1.13279 20.0417 0.740663 19.8792 0.451544 19.5901C0.162425 19.301 0 18.9089 0 18.5C0 18.0911 0.162425 17.699 0.451544 17.4099C0.740663 17.1208 1.13279 16.9583 1.54167 16.9583H16.9583V1.54167C16.9583 1.13279 17.1208 0.740663 17.4099 0.451544C17.699 0.162425 18.0911 0 18.5 0V0Z'
                  fill='#C2C2C2'
                />
              </svg>
            </p>
            <p className='text-gray'>اضافه خدمة جديدة</p>
          </div>
        )}
      </div>
    </div>
  );
};
export default ServicesContainer;
